import { useState } from "react";
import { BatchReviews } from "./BatchReviews";
import { ExceptionOrders } from "./ExceptionOrders";
import "./exception-workspace.css";

type QueryType = "single" | "batch";
const tabs = [
  { type: "single", label: "单笔查询" },
  { type: "batch", label: "批量查询" },
] as const;

export function ExceptionOrderTabs({ type, onChange }: {
  type: QueryType;
  onChange: (type: QueryType) => void;
}) {
  return <section className="exception-workspace">
    <div className="platform-order-tabs" role="tablist" aria-label="异常订单查询类型">
      {tabs.map(tab => <button
        key={tab.type}
        id={`exception-tab-${tab.type}`}
        type="button"
        role="tab"
        aria-selected={type === tab.type}
        aria-controls={`exception-panel-${tab.type}`}
        tabIndex={type === tab.type ? 0 : -1}
        className={type === tab.type ? "is-active" : ""}
        onClick={() => onChange(tab.type)}
        onKeyDown={event => {
          if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === "Home" ? "single" : event.key === "End" ? "batch" : type === "single" ? "batch" : "single";
          onChange(next);
          document.getElementById(`exception-tab-${next}`)?.focus();
        }}
      >{tab.label}</button>)}
    </div>
    <div role="tabpanel" id={`exception-panel-${type}`} aria-labelledby={`exception-tab-${type}`}>
      {type === "single" ? <ExceptionOrders /> : <BatchReviews />}
    </div>
  </section>;
}

export function ExceptionOrdersWorkspace() {
  const [type, setType] = useState<QueryType>("single");
  return <ExceptionOrderTabs type={type} onChange={setType} />;
}
